import React from 'react';
import { FaSpinner } from 'react-icons/fa';

const LoadingModal = ({ isOpen, message = 'Loading...' }) => {
  if (!isOpen) return null;

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000
    },
    modal: {
      backgroundColor: '#FFFAFA',
      borderRadius: '8px',
      padding: '30px',
      width: '400px',
      maxWidth: '90%',
      textAlign: 'center',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    spinner: {
      color: '#243444',
      fontSize: '40px',
      animation: 'spin 1.5s linear infinite',
      marginBottom: '20px'
    },
    message: {
      color: '#4C5454',
      fontSize: '18px',
      fontWeight: '500'
    },
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' }
    }
  };

  // Add the keyframes animation to the document
  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .spinner-animation {
      animation: spin 1.5s linear infinite;
    }
  `;
  document.head.appendChild(styleSheet);

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <FaSpinner className="spinner-animation" style={styles.spinner} />
        <div style={styles.message}>{message}</div>
      </div>
    </div>
  );
};

export default LoadingModal;
